export default __webpack_public_path__ + "static/media/devsigner.04fb58d7.svg";